import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation/dist/localization/messages_ru';

import {goAjaxForm, captchaRefresh} from '../common/ajax-form';

const reg = ($form) => {
    goAjaxForm({
        $form: $form,
        show_msg_ok: false,
        scroll: false,
        warning: true,
        onError: () => {
            captchaRefresh($form);
        },
        onSuccess: (data) => {
            window.location.href = data.redirect_to;
        },
    });
};

const showRegProfileForm = prefix => {
    $('.form-part').hide();
    $('#id_form_part_' + prefix).show();
};

$(function () {
    const $form = $('#id_reg_form');
    if ($form.length) {
        const $tp = $('#id_type');
        const $opt = $('option:selected', $tp);
        const prefix = $opt.data('type');
        showRegProfileForm(prefix);
        $form.validate();
        $tp.change(function () {
            const prefix = $('option:selected', this).data('type');
            showRegProfileForm(prefix);
        });
        reg($form);
    }
});



// WEBPACK FOOTER //
// ./js/accounts/registration.js